import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// images
import imageDesktopWebp from './images/three-business-owners-desktop.webp';
import imageMobileWebp from './images/three-business-owners-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-financial-access-investment-impact-section'
    themeType='lightTheme'
    backgroundVariant='lightA'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent={false}
    // content
    subHeadingText={<>Powering change through <WidowBlock>responsible investment</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='typography'>
          Maximizing long&#45;term value for our policyowners is our first and foremost goal as a mutual company. Our General Account strives to earn superior risk&#45;adjusted investment returns while maintaining our unsurpassed financial strength. We accomplish these results by having a well&#45;balanced, diversified portfolio that includes environmentally and socially responsible investments.
        </Typography>
        <Typography nextElement='button'>
          Our Impact Investment Fund directs capital to businesses that support and improve underserved communities, creating local and national economic benefits. Northwestern Mutual Future Ventures, our venture capital arm, includes investments that support entrepreneurs who have been underserved in accessing capital.
        </Typography>
        <Link
          id='sustainability-impact-financial-access-investment-impact-section-link'
          variant='buttonLinkSecondary'
          linkUrl='https://venture.northwesternmutual.com/future-ventures/'
          isOutgoingLink
          ariaLabel='Partner with us to increase financial access'>
          Learn more about Future Ventures
        </Link>
      </>
    )}
    // image props
    imageAltText='Three people having coffee and enjoying a conversation outdoors.'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
